module.exports = __webpack_public_path__ + "static/media/animal_03_big.16679ad8.png";